import { render, staticRenderFns } from "./advanced-search-chip.vue?vue&type=template&id=022ca6a8&scoped=true&"
import script from "./advanced-search-chip.vue?vue&type=script&lang=js&"
export * from "./advanced-search-chip.vue?vue&type=script&lang=js&"
import style0 from "./advanced-search-chip.vue?vue&type=style&index=0&id=022ca6a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ca6a8",
  null
  
)

export default component.exports